import { trackInternalEvent } from '@rio/tracking'
import { useDispatch } from 'react-redux'
import { useI18n } from 'builder/hooks/useI18n'
import { JobSearchNotificationType, RecommendAlert } from 'builder/modules/jobSearch/types'
import { actions as jobSearchActions } from 'builder/modules/jobSearch'
import { TooltipV2 } from 'builder/components/Tooltip'
import Icon24, { Icon20 } from 'builder/components/Icon'
import Toggle from 'builder/components/Toggle'
import { ButtonSize } from 'builder/components/Button'
import { SettingNew } from 'builder/components/Icon/24x24'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useMutationRecommendationAlert } from '../../../hooks/useMutationRecommendationAlert'
import { getLabel } from '../../../getLabel'
import { useTranslatedFrequenciesString } from '../../../hooks/useTranslatedFrequenciesString'
import {
  Container,
  ContainerText,
  ContainerTooltipItems,
  CustomButton,
  Frequency,
  SubTitle,
  TimeIcon,
  Title,
  Wrapper,
  WrapperNear,
  WrapperToggle,
} from './styles'

const TRANSLATION = 'builder.job_search.alert_modal'

interface Props {
  recommendedAlert: RecommendAlert | undefined
  onClick: () => void
}
export const RecommendedAlert = ({ recommendedAlert, onClick }: Props) => {
  const { i18n } = useI18n()
  const mutationRecommendationAlert = useMutationRecommendationAlert()
  const dispatch = useDispatch()
  const { isPhone } = useMediaQueries()

  const { getTranslatedTextFrequency } = useTranslatedFrequenciesString()

  const handleToggleChange = async () => {
    try {
      const newValue = !recommendedAlert?.active
      trackInternalEvent('switch_recommended_alert', {
        label: getLabel(),
        parameter: newValue ? 'on' : 'off',
      })
      await mutationRecommendationAlert.mutateAsync({
        data: { active: newValue },
        shouldUpdateCache: true,
      })
    } catch (e) {
      dispatch(jobSearchActions.setNotification(JobSearchNotificationType.snackbar_fail))
    }
  }

  return (
    <Container $enableHover={!!recommendedAlert?.active}>
      <Wrapper>
        <ContainerText>
          <Title>
            {i18n.t(`${TRANSLATION}.card_recommended.title`)}&nbsp;
            <WrapperNear>
              <Icon24.Near />
            </WrapperNear>
          </Title>

          <SubTitle>{i18n.t(`${TRANSLATION}.card_recommended.subtitle`)}</SubTitle>
        </ContainerText>

        <TooltipV2
          position="top"
          zIndex={12001}
          multiline
          content={i18n.t(`${TRANSLATION}.card_recommended.tooltip`)}
        >
          <ContainerTooltipItems>
            <Icon24.Info />
            <WrapperToggle>
              <Toggle
                disabled={mutationRecommendationAlert.isLoading}
                onClick={handleToggleChange}
                checked={recommendedAlert?.active}
              />
            </WrapperToggle>
          </ContainerTooltipItems>
        </TooltipV2>
      </Wrapper>
      <Frequency>
        <TimeIcon>
          <Icon20.Time />
        </TimeIcon>
        {recommendedAlert && getTranslatedTextFrequency(recommendedAlert?.frequency)}
      </Frequency>
      <CustomButton
        size={isPhone ? ButtonSize.small : ButtonSize.default}
        isDisabled={!recommendedAlert?.active}
        onClick={onClick}
      >
        <SettingNew />
        {i18n.t(`${TRANSLATION}.card_recommended.customize`)}
      </CustomButton>
    </Container>
  )
}
